import { mapState, mapActions, mapGetters } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    layoutScrollable: (state) => state.layoutScrollable,
    layoutMode: (state) => state.layoutMode,
    leftSidebarType: (state) => state.leftSidebarType,
    sidebarColor: (state) => state.sidebarColor,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
  }),
}

export const layoutMethods = mapActions('layout', [
  'changeLayoutType',
  'changeLayoutMode',
  'changeLayoutWidth',
  'changeLeftSidebarType',
  'changeTopbar',
  'changeSidebarColor',
  'changeLayoutPosition',
])

export const authMethods = mapActions('auth', ['authLogin', 'authLogout'])
export const authGetters = mapGetters('auth', [
  'authUser',
  'isAuthenticated',
  'authUserHasPermission',
  'authUserIsEzemanage',
])

export const graphMethods = mapActions('graph', [
  'changeGraphDurationStart',
  'changeGraphDurationEnd',
  'changeGraphInterval',
  'incrementGraphUpdate',
])
